import React, { useState } from 'react';
import { Box } from '@mui/material';
import { useToast } from '../../context/toastContext';
import ToastNotification from './ToastNotification';

const ToastContainer: React.FC = () => {
  const { toasts, removeToast } = useToast();
  const [isPaused, setIsPaused] = useState(false);

  return (
    <Box
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
      sx={{
        position: 'fixed',
        top: 24,
        right: 24,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        maxWidth: '420px',
        width: '100%',
        pointerEvents: 'none',
      }}
    >
      {toasts.map((toast) => (
        <ToastNotification
          key={toast.id}
          toast={toast}
          isPaused={isPaused}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </Box>
  );
};

export default ToastContainer;
